module.exports = __webpack_public_path__ + "media/pages/assets/images/calendar/2020/april-de360b28cb470bcd83f8ae21223cb1dc.png";